export const FETCH_USER = 'fetch_user';
export const FETCH_LOCKS = 'fetch_locks';
export const DELETE_LOCK = 'delete_lock';
export const UPDATE_LOCK = 'update_lock';
export const ENCRYPT = 'encrypt';
export const PASSCODE = 'passcode';
export const CHECK_URL = 'check_url';
export const PASSCODE_DECRYPTED = 'passcode_decrypted';
export const LOGIN_USER = 'login_user';
export const REGISTER_USER = 'register_user';
export const DECRYPT_DATA = 'decrypt_data';
export const FETCH_SECRET = 'fetch_secret';
export const CREATE_ANOTHER = 'create_another';
export const RESET_USER = 'reset_user';
export const SET_ERRORS = 'set_errors';
export const CLEAR_ERRORS = 'clear_errors';
export const DECRYPT_FAILED = 'decrypt_failed';